import { IChartType } from 'types'

export const shouldShowLegend = (chartType: IChartType): boolean => {
  if (chartType === null) return false
  return chartType !== 'gantt' && chartType !== 'bar' && chartType !== 'horizontal-bar' && chartType !== 'card'
}
